import { Link } from 'react-router-dom';

export default function ArticleEntry() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="rounded-2xl overflow-hidden mb-12">
          <img
            src="https://readdy.ai/api/search-image?query=Fashion%20collage%20with%20sneakers%20streetwear%20and%20luxury%20accessories%20artistically%20arranged%20on%20a%20warm%20cream%20surface%2C%20minimalist%20editorial%20style%2C%20soft%20natural%20lighting%2C%20earthy%20neutral%20tones%2C%20clean%20composition%20with%20negative%20space%2C%20high%20fashion%20aesthetic&width=1400&height=600&seq=article-entry-banner-01&orientation=landscape"
            alt="CSSBuy Spreadsheet Guide - Comprehensive resource for fashion shoppers"
            title="CSSBuy Spreadsheet Ultimate Guide"
            className="w-full h-auto"
            loading="lazy"
          />
        </div>

        <div className="text-center max-w-3xl mx-auto">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-snug mb-6">
            Master Your <span className="italic font-light text-foreground-500">CSSBuy Spreadsheet</span> Journey
          </h2>
          <p className="text-foreground-600 text-base leading-relaxed mb-10">
            From finding <strong className="text-foreground-900">verified fashion finds</strong> to connecting with <strong className="text-foreground-900">trusted sellers</strong>, our comprehensive guide covers everything you need to shop smarter, save money, and avoid common mistakes. Learn QC techniques, shipping strategies, and discover hidden gems other spreadsheets miss.
          </p>

          <Link
            to="/article/cssbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-primary-500 text-white text-base font-semibold hover:bg-primary-600 transition-all duration-200 hover:gap-3 whitespace-nowrap"
          >
            Read Full Guide
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-lg"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}